




















import 'normalize.css';
import '@/assets/sass/main.scss';
import { LOADER_DELAY, MOBILE_MAX_WIDTH } from '@/constants';
import auth from '@/services/auth';
import CmpDialog from '@/components/Dialog.vue';
import CmpLoader from '@/components/Loader.vue';

export default {
  mounted() {
    // listen to service worker updates
    window.onmessage = (message: any) => {
      if (message.data === 'service-worker-updated') {
        this.appUpdated = true;
      }
    };

    // set mobile state
    this.$store.commit('IS_MOBILE', (
      window.innerWidth <= MOBILE_MAX_WIDTH
    ));

    // logout when user information is removed
    this.$store.watch(
      (state: any, getters: any) => getters['auth/userId'],
      (userId: any) => {
        !userId && this.$store.commit('loader/ADD', {
          title: 'Logging out',
          promise: new Promise(resolve => (
            // logout with a delay to make it look more plausible
            setTimeout(() => {
              resolve();
              setTimeout(() => (
                this.$router.push({ name: 'home' })
              ), LOADER_DELAY);
            }, LOADER_DELAY)
          )),
        });
      },
    );
  },
  data: () => ({
    appUpdated: false,
  }),
  methods: {
    reload: () => location.reload(true),
  },
  watch: {
    $route(to: any, from: any) {

      // avoid actions on querystring changes
      if (to.name === from.name) {
        return;
      }

      // tracking
      analytics.page(to.name);

      // play sounds only within app
      if (to.meta.requiresAuth && from.name) {
        const toPage = to.fullPath.split('/').pop();
        const fromPage = from.fullPath.split('/').pop();
        const createPageKey = 'create';

        if (toPage === createPageKey) {
          // play create sound on create pages
          this.$sound.play('create');
        } else if (fromPage !== createPageKey) {
          // only play if not coming from create page
          // to prevent 2 sounds being played
          this.$sound.play('navigate');
        }
      }
    },
  },
  components: {
    CmpDialog,
    CmpLoader,
  },
} as IView;
